export default "__VITE_ASSET__B2GXSoz1__"